import { render, staticRenderFns } from "./PendingTable.vue?vue&type=template&id=687b4600&scoped=true&"
import script from "./PendingTable.vue?vue&type=script&lang=js&"
export * from "./PendingTable.vue?vue&type=script&lang=js&"
import style0 from "./PendingTable.vue?vue&type=style&index=0&id=687b4600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687b4600",
  null
  
)

export default component.exports